import React, { ChangeEvent, useEffect } from "react";
import { AppBar, Tabs as MuiTabs, Tab } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { HEADER_MIN_HEIGHT } from "../../../../../utils/constants";
import * as navigationService from "../../../../../features/navigation/services/navigation.service";

import { withShowIf } from "../../../../with-show-if/with-show-If.component";

import { createFragment, findTabToNavigateTo } from "../../types/tab.functions";
import { TabsPanel } from "../tabs-panel/tabs-panel.component";

import { TabsProps } from "./tabs.props";
import { useTabsStyles } from "./tabs.styles";
import { isNavigatingAway } from "./tabs.functions";

export const Tabs = withShowIf((props: TabsProps) => {
  const classes = useTabsStyles();
  const headerHeight = props.headerHeight ?? HEADER_MIN_HEIGHT;
  const { currentTabValue } = props;
  const history = useHistory();

  useEffect(() => {
    const tab = findTabToNavigateTo(history.location.hash, props.tabs[currentTabValue], props.tabs);
    if (tab) {
      props.handleTabChange(props.tabs.indexOf(tab));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTabChange = (event: ChangeEvent<{}>, value: number) => {
    if (
      isNavigatingAway(currentTabValue, value) &&
      props.shouldChangeTab(value, () => doTabChange(value))
    ) {
      doTabChange(value);
    }
  };

  const doTabChange = (value: number) => {
    navigationService.setFragment(createFragment(props.tabs[value]));
    props.handleTabChange(value);
  };

  return (
    <div className={classes.tabBar}>
      <AppBar className={classes.appBar} position="static" style={{ top: headerHeight }}>
        <MuiTabs
          aria-label={props.ariaLabel ?? "Tabs"}
          indicatorColor="primary"
          onChange={onTabChange}
          value={props.currentTabValue}
        >
          {props.tabs.map((tab, index) => (
            <Tab
              tabIndex={0}
              id={`simple-tab-${index}`}
              className={classes.tab}
              key={tab.title}
              label={tab.title}
              selected={props.tabs[props.currentTabValue].title === tab.title}
            />
          ))}
        </MuiTabs>
      </AppBar>
      <div className={classes.selectionContainer}>
        {props.tabs.map((tab, index) => (
          <TabsPanel key={tab.title} value={props.currentTabValue} index={index}>
            {tab.contents}
          </TabsPanel>
        ))}
      </div>
    </div>
  );
});
